/**
 * Logger class that provides logging functionality.
 */
export class Logger {
  private pDebug = console.info.bind(console);
  private pWarn = console.warn.bind(console);
  private pError = console.error.bind(console);
  private pTrace = console.trace.bind(console);

  constructor() {}

  /**
   * Get the debug console method.
   * @returns The debug console method.
   */
  get debug() {
    return this.pDebug;
  }

  /**
   * Get the warn console method.
   * @returns The warn console method.
   */
  get warn() {
    return this.pWarn;
  }

  /**
   * Get the error console method.
   * @returns The error console method.
   */
  get error() {
    return this.pError;
  }

  /**
   * Get the trace console method.
   * @returns The trace console method.
   */
  get trace() {
    return this.pTrace;
  }
}
